import React from 'react';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import Poster, { Props as PosterProps } from '../poster';

export interface Props {
  poster?: PosterProps;
  children?: JSX.Element[];
  maxHeight?: number;
}

export default function MenuFeed({ poster, ...props }: Props) {
  return (
    <Stack style={{ maxHeight: props.maxHeight ?? 640, overflowY: 'auto' }}>
      {poster ? (
        <Stack alignItems="center" justifyContent="center">
          <Poster {...poster} />
        </Stack>
      ) : (
        <List disablePadding sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {props.children}
        </List>
      )}
    </Stack>
  );
}
